import moment from 'moment'
import { sha256 } from '@util/helper'
import CryptoJS from 'crypto-js'
import { showSnackbar } from '@context/SnackbarContext'
import { emailRegex } from '@util/helper'
import { MAX_FILE_SIZE } from '@util/constant'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'

// 상품코드별 계약 개월 수 (자유결제 P100 은 기간 없음)
export const productMonths = {
  P001: 6,
  P002: 12,
  P003: 24,
}

export const getProductMonth = (productCode) => productMonths[productCode] ?? 0

export const createOrderNo = () => {
  const random = Math.floor(Math.random() * 1000000)
  const ftime = moment().format('YYYYMMDDHHmmss')
  const orderNo = `${ftime}${random}`.slice(0, 16)
  return orderNo
}

export const createOrder = () => {
  const now = moment().format(dateFormat)
  const order = {
    id: -1,
    orderNo: -1,
    branchId:1,
    roomId: -1,
    productDetail:'',
    repName: '',
    repPhone: '',
    contactName: '',
    contactPhone: '',
    companyName: '',
    industry: '',
    email: '',
    civilNum: '',
    civilNum1: '',
    civilNum2: '',
    zipCode: '',
    addr1: '',
    addr2: '',
    bizCode: '',
    bizNum: '',
    bizNum1: '',
    bizNum2: '',
    bizNum3: '',
    corpNum: '',
    corpNum1: '',
    corpNum2: '',
    emailSvcYn: 'N',
    destroySvcYn: 'N',
    rmailSvcYn: 'N',
    channelCode: '',
    privacyYn: '',
    paymentKey: '',
    fax: '',
    faxDial: '',
    fax1: '',
    fax2: '',
    statCode: 'S000',
    claimYn: 'N',
    amount: 0,
    customId: '',
    remark: '',
    startTime: null,
    endTime: null,
    note1: '',
    note2: '',
    note3: '',
    bookYn: 'N',
    bookRemark:'',
    uptTime: now,
    regTime: now,
  }
  return order
}

export const fakeOrder = () => {
  const now = moment().format(dateFormat)
  const random = Math.floor(Math.random() * 1000000)
  const ftime = moment().format('YYYYMMDDHHmmss')
  const orderNo = `${ftime}${random}`.slice(0, 16)
  // const customId = CryptoJS.SHA256(`${name}${orderNo}`).toString().slice(0, 16)
  const customId = CryptoJS.SHA256(`${orderNo}`).toString().slice(0, 16)
  const order = {
    id: -1,
    orderNo: -1,
    branchId:1,
    roomId: -1,
    productDetail:'',
    repName: '홍길동',
    repPhone: '01011112222',
    contactName: '홍길동',
    contactPhone: '01011112222',
    companyName: '(주)알파컴퍼니',
    industry: '서비스',
    email: 'test@example.com',
    civilNum: '1111112222222',
    civilNum1: '111111',
    civilNum2: '2222222',
    zipCode: '202333',
    addr1: '서울시 중구 남대문로1가 27길13',
    addr2: '101',
    bizCode: 'B001',
    bizNum: '1112233333',
    bizNum1: '111',
    bizNum2: '22',
    bizNum3: '33333',
    corpNum: '',
    corpNum1: '',
    corpNum2: '',
    emailSvcYn: 'N',
    destroySvcYn: 'N',
    rmailSvcYn: 'N',
    channelCode: 'C001',
    privacyYn: 'Y',
    paymentKey: '',
    fax: '',
    faxDial: '',
    fax1: '',
    fax2: '',
    statCode: 'S000',
    claimYn: 'N',
    amount: 0,
    customId: '',
    remark: '',
    startTime: null,
    endTime: null,
    note1: '',
    note2: '',
    note3: '',
    bookYn: 'N',
    bookRemark:'',
    uptTime: now,
    regTime: now,
  }
  return order
}

// 자유결제(P100) 화면에서 제거한 항목: 업종, 주소, 사업자 유형 (validateInputs 검사 제외)
export const customSkipKeys = ['industry', 'zipCode', 'addr1', 'addr2', 'bizCode']

// 입력값 검사만 수행: 기간 계약(contract1)과 자유결제(contract-custom) 공용
// skipKeys: 화면에 입력란이 없어 검사하지 않을 항목
export const validateInputs = (order, inputsRef, theme, skipKeys = []) => {
  for (const [key, value] of Object.entries(order)) {
    if (skipKeys.includes(key)) {
      continue
    }
    if (key === 'repName') {
      if (!inputsRef.current[key].value) {
        showSnackbar('대표자명이 비어 있습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'repPhone') {
      if (inputsRef.current[key].value.length < 11) {
        showSnackbar('대표자 연락처가 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'contactName') {
      if (!inputsRef.current[key].value) {
        showSnackbar('담당자명이 비어 있습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'contactPhone') {
      if (inputsRef.current[key].value.length < 11) {
        showSnackbar('담당자 연락처가 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'companyName') {
      if (!inputsRef.current[key].value) {
        showSnackbar('상호명이 비어 있습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'industry') {
      if (!inputsRef.current[key].value) {
        showSnackbar('업종명이 비어 있습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'email') {
      if (!emailRegex.test(inputsRef.current[key].value)) {
        showSnackbar('이메일 형식이 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'civilNum1' || key === 'civilNum2') {
      const civilNum = inputsRef.current['civilNum1'].value + inputsRef.current['civilNum2'].value
      if (civilNum.length != 13) {
        showSnackbar('주민번호 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }

      order.civilNum1 = inputsRef.current['civilNum1'].value
      order.civilNum2 = inputsRef.current['civilNum2'].value
      order.civilNum = civilNum
    }

    if (key === 'zipCode') {
      if (!inputsRef.current[key].value) {
        showSnackbar('주소가 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }

      order[key] = inputsRef.current[key].value
    }

    if (key === 'addr1') {
      if (!inputsRef.current[key].value) {
        showSnackbar('주소가 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'addr2') {
      if (!inputsRef.current[key].value) {
        showSnackbar('상세 주소가 올바르지 않습니다.', theme.palette.warning.dark)
        inputsRef.current[key].focus()
        return
      }
      order[key] = inputsRef.current[key].value
    }

    if (key === 'bizCode') {
      if (!value) {
        showSnackbar('사업자 유형을 선택해 주세요.', theme.palette.warning.dark)
        const radioButtons = document.querySelectorAll('input[type="radio"][name="bizCode"]')
        radioButtons[0]?.focus()
        return
      }
    }

    if (key === 'bizNum1' || key === 'bizNum2' || key === 'bizNum3') {
      const bizNum =
        inputsRef.current['bizNum1'].value + inputsRef.current['bizNum2'].value + inputsRef.current['bizNum3'].value
      if (bizNum.length !== 0) {
        if (bizNum.length !== 10) {
          showSnackbar('사업자등록번호가 올바르게 입력되지 않았습니다.', theme.palette.warning.dark)
          inputsRef.current[key]?.focus()
          return
        }
      }
      order.bizNum1 = inputsRef.current['bizNum1'].value
      order.bizNum2 = inputsRef.current['bizNum2'].value
      order.bizNum3 = inputsRef.current['bizNum3'].value
      order.bizNum = bizNum
    }

    if (key === 'corpNum1' || key === 'corpNum2') {
      const corpNum = inputsRef.current['corpNum1'].value + inputsRef.current['corpNum2'].value
      if (corpNum.length !== 0) {
        if (corpNum.length !== 13) {
          showSnackbar('법인등록번호가 올바르게 입력되지 않았습니다.', theme.palette.warning.dark)
          inputsRef.current[key]?.focus()
          return
        }
      }
      order.corpNum1 = inputsRef.current['corpNum1'].value
      order.corpNum2 = inputsRef.current['corpNum2'].value
      order.corpNum = corpNum
    }

    if (key === 'destroySvcYn') {
      if (value === 'N') {
        showSnackbar(
          '우편물, 택배 보관 기간 초과 시 폐기에 동의하지 않으면 계약이 불가합니다.',
          theme.palette.warning.dark
        )
        const radioButtons = document.querySelectorAll('input[type="radio"][name="mail_dispose"]')
        radioButtons[0]?.focus()
        return
      }
    }
    if (key === 'channelCode') {
      if (!value) {
        showSnackbar('알게되신 경로를 선택해 주세요.', theme.palette.warning.dark)
        const radioButtons = document.querySelectorAll('input[type="radio"][name="known"]')
        radioButtons[0]?.focus()
        return
      }
    }
    if (key === 'privacyYn') {
      if (value !== 'Y') {
        showSnackbar('개인정보 수집 및 이용동의를 하지 않으면 계약이 불가합니다.', theme.palette.warning.dark)
        const radioButtons = document.querySelectorAll('input[type="radio"][name="privacy"]')
        radioButtons[0]?.focus()
        return
      }
    }
  }

  return true
}

// 기간 계약용: 입력값 검사 + 상품 가격(note1) + 우편물 실물 발송(월 1만원 x 개월 수)
export const validate = (order, inputsRef, theme, productCodes) => {
  if (!validateInputs(order, inputsRef, theme)) {
    return
  }

  const product = productCodes.find((r) => r.code === order.productCode)
  const month = getProductMonth(order.productCode)
  if (!product || !month) {
    showSnackbar('계약할 수 없는 상품입니다.', theme.palette.warning.dark)
    return
  }

  const amount = +product.note1 + (order.rmailSvcYn === 'Y' ? 10000 * month : 0)
  const mAmount = +amount / +month

  order.amount = amount
  // for convinence
  order.month = month
  order.mAmount = mAmount

  return true
}

export const checkFileSize = (files, theme) => {
  if(files.size > 5) {
    showSnackbar('파일은 5개 이하만 가능합니다.', theme.palette.warning.dark)
    return false
  }
  for(let i=0; i < files.length; i++) {
    if(files[i].size > MAX_FILE_SIZE) {
      showSnackbar('파일 크기는 3MB 이하만 가능합니다.', theme.palette.warning.dark)
      return false
    }
  }
  return true
}
